import React from 'react'
import { Typography as MuiTypography, makeStyles } from "@material-ui/core";
import { red, orange, green } from '@material-ui/core/colors';

const useStyles = makeStyles(() => ({
    root: {
    },
    success: {
        color: green[500],
    },
    danger: {
        color: red[500],
    },
    warning: {
        color: orange[500],
    },
}))
export default function Typography(props) {
    const { status, ...other } = props
    const classes = useStyles();

    return (
        <MuiTypography
            {...other}
            className={`${classes.root} ${classes[status]}`}
        />

    )
}
